import { useCallback, useState } from 'react';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';

import BillingMigrationSessionsList from './BillingMigrationSessionsList';
import BillingMigrationUploadModal from './BillingMigrationUploadModal';

export default function BillingMigrationTab() {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [refreshSessions, setRefreshSessions] = useState(false);

  const handleUploadSuccess = useCallback(() => {
    setUploadModalOpen(false);
    setRefreshSessions(prev => !prev);
  }, []);

  return (
    <>
      <Card
        elevation={0}
        sx={{ border: '1px solid', borderColor: 'grey.200', borderRadius: 2 }}
      >
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Billing Data Migration
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Import historical claims and ERA files from external billing systems.
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<UploadFileIcon />}
              onClick={() => setUploadModalOpen(true)}
            >
              Upload Files
            </Button>
          </Box>

          <BillingMigrationSessionsList onRefresh={refreshSessions} />
        </CardContent>
      </Card>

      <BillingMigrationUploadModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
        onSuccess={handleUploadSuccess}
      />
    </>
  );
}
